import TileActionResult from 'app/src/engine/action-results/TileActionResult';
import ConveyorTile from 'app/src/engine/tiles/ConveyorTile';
import { TileLocation } from 'app/src/engine/tiles/Tile';

export enum ConveyorTileActionResultType {
	Move,
	Bounce,
}

export default class ConveyorTileActionResult extends TileActionResult {
	public type: ConveyorTileActionResultType;

	constructor(
		conveyorTile: ConveyorTile,
		location: TileLocation,
		type: ConveyorTileActionResultType = ConveyorTileActionResultType.Move,
	) {
		super(conveyorTile, location);

		this.type = type;
	}

	public clone(): ConveyorTileActionResult {
		return new ConveyorTileActionResult(this.tile as ConveyorTile, this.location, this.type);
	}
}
